/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as VotesAct from '../../Actions/VoteActions';
import { getGlyphe, toCalendrier, toDate, fromNow } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import TableauV from '../TableauV';
import { obtenirVotantAvecVotes } from '../../App_Code/API';
import LigneVote from './LigneVote';
import CardRapport from './CardRapport';
import * as Actions from '../../Actions/DocActions';

const AfficheTableau = ({ votes }) => {
    const Entete = (
        <tr style={{backgroundColor:'#D9D9D9'}} >
            <th scope="col" className={`acc-table-vote`}>QUESTION</th>
            <th scope="col" className='text-center acc-td-vote'>POUR</th>
            <th scope="col" className='text-center acc-td-vote'>CONTRE</th>
            <th scope="col" className='text-center acc-td-vote'>ABSTENTION</th>
        </tr>
    );

    return <TableauV Entete={Entete} Lignes={votes} PasDeZebrures={true} PetitesLignes={true} />;
};

const AlertePasDevote = () => (
    <div className="jumbotron text-center">
        <span>aucune résolution</span>
    </div>
);

class MonAG extends Component {
    constructor(props) {
        super(props);

        let NumR=0
        if(this.props.location.state && this.props.location.state.NumReunion>0) {
            NumR=this.props.location.state.NumReunion
            this.props.actions.VoteMajNumReunion(NumR)
        }
        if(this.props.match.params.id>0 && NumR<1) {
            NumR=this.props.match.params.id
            this.props.actions.VoteMajNumReunion(NumR)
        }
        if(NumR<1) {
            NumR=this.props.NumReuSel
        }

        const lareuTab = this.props.LsReunions.filter(Reu => Reu.NumReunion == NumR);
        let lareu = null
        if (lareuTab.length>0) {
            lareu=this.props.LsReunions.filter(Reu => Reu.NumReunion == NumR)[0]
        };

        this.state = {
            StateNumReunion: NumR,
            StateReunion: lareu,
            StateVotant: null,
            StateLsVotes:null,
            DialogVote:false,
        };

    }
    componentDidMount() {
        if (this.state.StateNumReunion<1) {return false}
        obtenirVotantAvecVotes(this.state.StateNumReunion).then((data) => {
            if (data) { this.setState({ StateVotant: data, StateLsVotes: data.LsVotes })};
        });
    }

    toggleDialogVote = () => {
        this.setState({
            DialogVote: !this.state.DialogVote,
        });

    };


    render() {
        const {
        StateReunion, StateVotant, StateLsVotes,
        } = this.state;

        if (!StateReunion || !StateVotant || !StateLsVotes) { return false }
        let d1 = new Date(StateReunion.VoteFin);
        let dh = new Date();
        let sdh = dh.toDateString();
        let d2 = new Date(sdh);
        let futur =0 
        d1>=d2 ? futur=1 : futur=0
        let nbd=Math.floor((d1-d2)/1000/60/60/24)
        let l1 = ""
        let l2 = ""
        let ico = "RIEN"
        let TextVote=''
        let TextValide=''

        if (StateVotant.EtatReu != 1 && futur==1) {l1="Votes actuellement fermés"}
        if (StateVotant.EtatReu != 1 && futur==0) {l1=`Votes fermés depuis le ${toDate(StateReunion.VoteFin, 'DD/MM/YYYY')}`}
        if (StateVotant.EtatReu == 1) {l1=`Votes ouverts jusqu'au ${toDate(StateReunion.VoteFin, 'DD/MM/YYYY')}`}

        if (StateVotant.EtatReu != 1 && futur==1 && StateVotant.EtatVotePro==1) {l2=``}
        if (StateVotant.EtatReu != 1 && ( StateVotant.EtatVotePro==2 || StateVotant.EtatVotePro==3)) {l2=`Vos votes n'ont pas été validés`}

        if (StateVotant.EtatVotePro==4) {l2=`Vous avez validé vos votes`}
        if (StateVotant.EtatVotePro==5) {l2=`Votre formulaire a été receptionné par le syndic`}
        if (StateVotant.EtatVotePro==6) {l2=`Vos votes ont été recus et enregistrés par le syndic`}

        if (StateVotant.EtatReu == 1 && futur==1 && ( StateVotant.EtatVotePro==2 || StateVotant.EtatVotePro==3) && nbd==0) {l2=`C'est le dernier jour pour valider vos votes`}
        if (StateVotant.EtatReu == 1 && futur==1 && ( StateVotant.EtatVotePro==2 || StateVotant.EtatVotePro==3) && nbd>0) {l2=`Il vous reste ${nbd+1} jours pour valider vos votes`}
        if (StateVotant.EtatReu == 1 && ( StateVotant.EtatVotePro==1 )) {l2=`Vous pouvez commencer à voter`}
        if (StateVotant.EtatReu != 1 && futur==0 && StateVotant.EtatVotePro==1) {l2=`Vous n'avez pas voté par formulaire en ligne`}


        if ((StateVotant.EtatVotePro==2 || StateVotant.EtatVotePro==3)) {ico=`ALERTE`}
        if (StateVotant.EtatVotePro>=4) {ico=`OK`}
       
        if (StateVotant.EtatReu == 1 && ( StateVotant.EtatVotePro==1 )) {TextVote=`Commencer à voter`}
        if (StateVotant.EtatReu == 1 && ( StateVotant.EtatVotePro==2 || StateVotant.EtatVotePro==3)) {TextVote=`Modifier mes votes`}
        if (StateVotant.EtatReu == 1 && ( StateVotant.EtatVotePro==2 || StateVotant.EtatVotePro==3)) {TextValide=`Valider mes votes`}

        let NumBV=0
        let docs= []
        if (StateVotant.EtatVotePro>=4) {
            NumBV=StateVotant.FormRetourNumBVHisto
        }
        docs=this.props.Docs.filter(doc => doc.Id==NumBV)
        const listeDocsFiltrer = docs.map((doc, i) => <CardRapport key={i} Doc={doc} actions={this.props.actionsDocs} />);


        let voter=0
        if (TextVote.length>0) {voter=1}

        let lsvotes = null
        if (StateLsVotes) {
            lsvotes = StateLsVotes.map((vote, index) => ( 
                <LigneVote key={vote.NumVoteForm} Vot={vote} index={index} voter={voter} />
            ));
        }

        return (
            <React.Fragment>
                <div className="d-flex justify-content-between acc-header-liste">
                    <div  className="media-body small acc-header-nom">
                        {StateReunion.Nom} <br/>Le {toDate(StateReunion.DateDebut, 'DD/MM/YYYY')} à {toDate(StateReunion.DateDebut, 'HH:mm')}
                    </div>

                    <div  className="media-body small text-center">
                        <span style={{fontWeight:"normal"}}>
                            {/* EtatReu : {StateVotant.EtatReu} - futur : {futur} - EtatVotePro : {StateVotant.EtatVotePro} - ico : {ico} <br/> */}
                        {l1}<br/>
                        <p className={`${ico=='ALERTE' ? "card acc-valide-erreur" : ""} `}><span style={{fontWeight:"600"}}>
                            {ico=='OK' ? <i className='fa fa-lg fa-check text-success' style={{paddingLeft:'10px',paddingRight:'5px', fontSize:'1.2rem'}} /> : null}
                            {ico=='ALERTE' ? <i className='fa fa-exclamation-triangle fa-lg acc-ico-erreur' style={{color:'#DC3545',paddingLeft:'10px',paddingRight:'5px', fontSize:'1.2rem'}} /> : null}                    
                            {l2}</span>
                        </p><br/>&nbsp;</span>
                    </div>

                    <div className='media-body acc-header-btn'>
                        {TextVote.length>0 ? (
                        <Link
                            to={`/MesInformations/MonAG/MesVotes/${this.state.StateNumReunion}`}
                            className="btn btn-outline-primary float-right mb-1"
                            style={{width:'180px',whiteSpace:'nowrap'}}
                        >
                            {TextVote}
                        </Link>
                        ) : ( null)}                        
                        
                        {TextValide.length>0 ? (
                            <Link
                            to={`/MesInformations/MonAG/MesVotes/MaSignature/${this.state.StateNumReunion}`}
                                className="btn btn-success float-right mb-1"
                                style={{width:'180px',whiteSpace:'nowrap'}}
                            >{TextValide}</Link>
                        ) : ( null)}
                        {StateVotant.EtatVotePro>=4  && NumBV>0 && docs.length===1 ? <div className='acc-doc-vote'>{listeDocsFiltrer}</div> : null }
                    </div>
                </div>
                {lsvotes ? <AfficheTableau votes={lsvotes} />: <AlertePasDevote />}
                </React.Fragment>
        );
    }
}
MonAG.displayName = 'MonAG';
MonAG.requiredProps = [
    'NumReuSel', // Num Reunion selectionnée pour le vote
    'LsReunions', // Liste Reunions trouvées
    'Docs', // Liste Reunions trouvées
];

function mapStateToProps({ 
    CopStore: {
        Cop: { LsReunions },
    },
    VoteStore: { NumReuSel, Votant },
    DocStore: { Filtres, Docs },
    
}) {
    return {NumReuSel, LsReunions, Docs };
}

function mapDispatchToProps(dispatch) {
    return { 
        actions: bindActionCreators(VotesAct, dispatch),
        actionsDocs: bindActionCreators(Actions, dispatch)

     };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(MonAG));



// WEBPACK FOOTER //
// ./src/components/MonAG/index.js